<template>
    <v-data-table
        :headers="headers"
        :items="samples"
        item-key="uuid"
        height="65vh"
        :loading="controls.loading"
        show-expand
        hide-default-header
        hide-default-footer
        disable-pagination
        single-expand
    >
      <template v-slot:top>
        <v-row class="pa-0 ma-0">
          <v-col cols="6" md="3">
            <MasterQuery :default_query="default_query" @query="loadQuery($event)"></MasterQuery>
          </v-col>
          <v-col>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <SampleFilterOptions ref="sample_filter" :default_query="default_filter" @query="loadQuery()"></SampleFilterOptions>
            </template>
            <template v-else>
              <v-dialog v-model="controls.showFilterDialog">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on"  outlined>Filter Options</v-btn>
                </template>
                <v-card>
                  <CardTitle title="Filter Options">
                    <template v-slot:actions>
                      <v-btn @click="controls.showFilterDialog = false" icon small><v-icon>close</v-icon></v-btn>
                    </template>
                  </CardTitle>
                  <v-card-text>
                    <SampleFilterOptions ref="sample_filter" :default_query="default_filter" @query="loadQuery()"></SampleFilterOptions>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>
          </v-col>
        </v-row>
      </template>
      <template v-slot:header="prop">
        <TrackingTableHeader :headers="prop.props.headers" @query="loadQuery($event)" :loading="controls.loading" sticky></TrackingTableHeader>
      </template>
      <template v-slot:item.data-table-expand="{item, expand, isExpanded}">
        <SampleContextMenu :sample="{uuid: item.uuid, id: item.id, qa_approved: item.qa_approved, is_released: item.is_released, customer_id: item.customer_id, sample_flags: item.sample_flags}" :key="item.id">
          <template v-slot:activator="{show}">
            <v-list-item @click="expand(!isExpanded)" @contextmenu="show" :ref="item.id" link  :class="isExpanded ? 'primary darken-2' : ''" style="white-space:nowrap" class="pa-0">
              <v-badge v-if="item.is_released" color="success" icon="mdi-check" right tile inline>
                <template v-slot:badge>
                  <v-icon x-small>mdi-check</v-icon> Released
                </template>
                <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
              </v-badge>
              <v-badge v-else-if="item.qa_approved" color="purple" icon="mdi-check" right tile inline>
                <template v-slot:badge>
                  <v-icon x-small>mdi-check</v-icon> Approved
                </template>
                <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
              </v-badge>
              <v-badge v-else-if="$moment().diff($moment(item.created_at), 'days') > 3" color="error" right tile inline>
                <template v-slot:badge>
                  {{$moment().diff($moment(item.created_at), 'days')}} Aging
                </template>
                <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
              </v-badge>
              <v-badge v-else color="secondary" right tile inline>
                <template v-slot:badge>
                  <v-icon x-small>mdi-loading</v-icon> Active
                </template>
                <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
              </v-badge>
              <!--                <div v-else :class="isExpanded ? 'white&#45;&#45;text' : ''">{{item.id}}</div>-->
            </v-list-item>
          </template>
        </SampleContextMenu>
      </template>
      <template v-slot:item.uuid="{item}">
        <td style="white-space:nowrap; width:1%">
          <RequiredTests :sample="item" chips show_count></RequiredTests>
        </td>
      </template>
      <template v-slot:item.name="{item}">
        <template v-if="item.name.length <= 15">{{item.name}}</template>
        <v-tooltip v-else bottom>
          <template v-slot:activator="{on}">
            <span v-on="on">{{item.name.substring(0,12)}}...</span>
          </template>
          <span>{{item.name}}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.customer="{item}">
        <template v-if="item.assigned_name">{{item.assigned_name.name}}</template>
        <template v-else>{{item.customer ? item.customer.primary_name.name : ''}}</template>
      </template>
      <template v-slot:item.created_at="{item}">
        <v-tooltip bottom>
         <template v-slot:activator="{on}">
           <span v-on="on">{{ $moment.utc(item.created_at).local().fromNow() }}</span>
         </template>
          <span>{{ $moment.utc(item.created_at).local().format("YYYY-MM-DD HH:mm") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{item, headers}">
        <td :colspan="headers.length">
          <slot name="expanded_item" :item="item" :header_length="headers.length"></slot>
        </td>
      </template>
      <template v-slot:item.sample_flags="{item}">
        <v-tooltip color="grey darken-3" bottom>
          <template v-slot:activator="{on}">
            <v-chip v-on="on" color="secondary" class="white--text pa-1"  small label>{{item.sample_notes.length}} notes</v-chip>
          </template>
          <template v-if="item.sample_notes.length > 0" v-for="(note, index) in item.sample_notes">
            <span :key="note.uuid">({{note.note_type.name}}) - {{note.note}}</span>
            <v-divider class="grey" :key="index"></v-divider>
          </template>
          <span v-else>No Notes</span>
        </v-tooltip>
        <template v-if="item.sample_flags.length > 0">
          <v-tooltip v-for="flag in item.sample_flags" :key="flag.uuid" color="grey darken-3" bottom>
            <template v-slot:activator="{on}">
              <v-chip v-on="on" :color="flag.flag_type.color" class="white--text pa-1"  small label>
                <span v-if="flag.flag_type.name.split(' ').length > 1">{{flag.flag_type.name.split(' ').map(text => text[0]).join('')}}</span>
                <span v-else>{{flag.flag_type.name.substring(0,3)}}</span>
              </v-chip>
            </template>
            <span>{{flag.flag_type.name}}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:footer>
        <TablePaginationFooter store_model="samples" @next="loadQuery(false, $event)"></TablePaginationFooter>
      </template>
    </v-data-table>
</template>

<script>
import SampleFilterOptions from "./SampleFilterOptions";
export default {
  name: "index",
  components: {
    TrackingTableHeader: () => import('@/components/general/samples/SampleTrackingTableHeader'),
    TablePaginationFooter: () => import('@/components/general/TablePaginationFooter'),
    SampleContextMenu: () => import("@/components/general/samples/SampleContextMenu"),
    RequiredTests: () => import("@/components/general/samples/RequiredTests"),
    MasterQuery: () => import("@/components/QueryBuilder/MasterQuery"),
    SampleFilterOptions
  },
  data: () => ({
    controls: {
      scopedQueries: [],
      showFilterDialog: false,
      filterOptions: {
        sample_id_desc: false,
        qa_approved: false,
        is_released: false,
      },
      loading: false,
    },
    tableHeaders : [
      {
        text: 'Sample id',
        value: 'data-table-expand',
        show: true,
        queryable: {type: 'text', key: 'id', value: null},
        class: 'sticky-header'
      },
      {
        text: 'Tests',
        value: 'uuid',
        sortable: false,
        show:true,
        queryable: {type: 'multi-select', model: 'sampleTestTypes',relation: 'sampleTests', value: []},
        class: 'sticky-header'
      },
      {
        text: 'Flags',
        value: 'sample_flags',
        sortable: false,
        show:true,
        queryable: {type: 'multi-select', model: 'sampleFlagTypes', relation: 'sampleFlags', value: []},
        class: 'sticky-header'
      },
      {
        text: 'Type',
        value: 'sample_cert_type.name',
        show: true,
        queryable: {type: 'multi-select', key: 'sample_cert_type_uuid', model: 'sampleCertTypes', value: []},
        class: 'sticky-header'
      },
      {
        text: 'Customer',
        value: 'customer',
        show: true,
        queryable: {type: 'multi-select', key: "customer_id", model: 'names', value: [], aka: {model: 'names', key: 'customer_id', text: 'name', filter: true,}},
        class: 'sticky-header'
      },
      {
        text: "Name",
        value: "name",
        show: true,
        queryable: {type: "text", key: "name", value: null},
        class: 'sticky-header'
      },
      {
        text: "qa",
        value: "qa",
        show: true,
        queryable: { type: 'text', key: 'qa', value: null,},
        class: 'sticky-header'
      },
      {
        text: "lot",
        value: "lot",
        show: true,
        queryable: { type: 'text', key: 'lot', value: null,},
        class: 'sticky-header'
      },
      {
        text: "RND",
        value: "is_rnd",
        show: true,
        queryable: {type: 'boolean', key: 'is_rnd', value: null},
        class: 'sticky-header'
      },
      {
        text: "Manifest ID",
        value: "manifest_id",
        queryable: {type: 'text', key: 'manifest_id', value: null},
        show: false,
        class: 'sticky-header'
      },
      {
        text: "Legal Type",
        value: "legal_type",
        queryable: {type: 'text', key: 'legal_type', value: null},
        show: false,
        class: 'sticky-header'
      },
      {
        text: "harvest_date",
        value: "harvest_date",
        queryable: false,
        show: false,
        class: 'sticky-header'
      },
      {
        text: "weight",
        value: "weight",
        show: false,
        queryable: false,
        class: 'sticky-header'
      },
      {
        text: "pieces",
        value: "pieces",
        show: false,
        queryable: false,
        class: 'sticky-header'
      },
      {
        text: "unit_uuid",
        value: "unit_uuid",
        show: false,
        queryable: false,
        class: 'sticky-header'
      },
      {
        text: "created_by",
        value: "created_by",
        show: false,
        queryable: false,
        class: 'sticky-header'
      },
      {
        text: "updated_by",
        value: "updated_by",
        show: false,
        queryable: false,
        class: 'sticky-header'
      },
      {
        text: "Created At",
        value: "created_at",
        show: true,
        queryable: false,
        class: 'sticky-header'
      },
      {
        text: "updated_at",
        value: "updated_at",
        show: false,
        queryable: false,
        class: 'sticky-header'
      }
    ]
  }),
  props:{
    default_query: {
      default: 0,
      type: Number
    },
    default_filter: {
      default: false,
      required: false,
    }
  },
  computed: {
    headers(){
      return this.tableHeaders.filter(header => header.show)
    },
    samples(){
      return this.$store.$db().model('samples').query().with(['sample_tests.test_type','sample_notes.note_type','sample_flags.flag_type', 'sample_type', 'sample_cert_type', 'customer', 'names', 'assigned_name',]).get();
    }
  },
  mounted(){
    Promise.all([
      this.$store.$db().model('customers').dispatch('getCustomers'),
      this.$store.$db().model('sampleFlagTypes').api().fetch(),
      this.$store.$db().model('sampleTypes').api().fetch(),
      this.$store.$db().model('sampleNoteTypes').api().fetch(),
      this.$store.$db().model('sampleCertTypes').api().fetch(),
      this.$store.$db().model('sampleTestTypes').api().fetch(),
    ])
  },
  methods: {
    async loadQuery(customQuery = false, next = false){
      console.log(customQuery, 'customQuery')
      this.controls.loading = true;
      await this.$store.$db().model('samples').deleteAll();
      await this.$store.$db().model('sampleTests').deleteAll();
      await this.$store.$db().model('sampleNotes').deleteAll();
      // await this.$store.$db().model('sampleTestsAnalytes').deleteAll();
      // await this.$store.$db().model('sampleTestAnalyteTypes').deleteAll();
      if(customQuery){
        this.customQuery = customQuery.raw ? {...customQuery.raw.query} : {...customQuery};
      }
      console.log('run query')
      await this.$store.$db().model('samples').api().fetch(this.addToQuery(this.customQuery),"", null, true, next);
      this.controls.loading = false;
    },
    addToQuery(query){
      if(!query) return;
      let sampleFilterQuery = this.$refs.sample_filter.buildQuery();
      console.log(sampleFilterQuery, 'query---', query)
      let whereHas = []
      if(query.where_has){
        if(Array.isArray(query.where_has)){
          whereHas = [...query.where_has];
        }else{
          whereHas = [query.where_has]
        }
      }
      if(sampleFilterQuery.where_has){
        whereHas = [...whereHas, ...sampleFilterQuery.where_has];
      }
      return {
        ...query,
        ...sampleFilterQuery,
        where: !sampleFilterQuery.where && !query.where ? []
            : !sampleFilterQuery.where && query.where
              ? query.where
                : sampleFilterQuery.where && !query.where
                  ? sampleFilterQuery.where
                    : [...query.where.filter(val => !sampleFilterQuery.where.some(where => where.key === val.key)), ...sampleFilterQuery.where],
        where_has: whereHas,
        paginate: 20,
        with: 'sampleFlags,sampleNotes,sampleTests',
      }
    }
  }
}
</script>

<style scoped>

</style>
